import { Routes } from '@angular/router';

import { CMS_PERMISSIONS } from '../../core/constants/permissions';
import { permissionGuard } from '../../core/guards/permission.guard';

export const userRoutes: Routes = [
  {
    path: 'usuarios',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.users.viewAny,
    },
    loadComponent: () => import('./pages/table/table').then((m) => m.UsersTable),
  },
  {
    path: 'usuarios/crear',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.users.create,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.UsersForm),
  },
  {
    path: 'usuarios/:id/editar',
    canActivate: [permissionGuard],
    data: {
      permission: CMS_PERMISSIONS.users.update,
    },
    loadComponent: () => import('./pages/form/form').then((m) => m.UsersForm),
  },
];
